import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { InfraLayout } from '../InfraLayout';
import { InfraEntities } from "../InfraEntities";
import { InfraRouterProps } from "../InfraRouterProps";

interface CloudListPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class CloudListPage extends Component<CloudListPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.cloud(this.props),
                    list: {}
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}